import { SegmentedControl } from "metabase/components/SegmentedControl";

function ChartSettingSegmentedControl(props) {
  return <SegmentedControl fullWidth {...props} />;
}

export default ChartSettingSegmentedControl;
